import * as React from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'


import './../styles/auth/auth.css'
import './../styles/auth/createUser.css'
import logo from './../images/logo.png'
import {Button, TYPES} from './../components/shared/button'
import Page from './../components/shared/page'


class CostAnalysisInvite extends React.Component {

  render () {
    return (
      <Page history={this.props.history}>
        <div className='create-user-container'>
          <div className='auth-box'>
          <img src={logo} alt='BayWatch Technologies' />
            <form onSubmit={this.onSubmit} >
              <input type='email' placeholder='Email' name='email' onChange={this.handleChange} className='auth-input'/>
              <div className='auth-button-container'>
                <Button
                  text='Invite User'
                  type='logIn'
                  buttonType={TYPES.SUBMIT}
                />
              </div>
            </form>
            <div className='auth-password-reset'>
              <Link to={'/admin/locations'}>
                <p>Cancel</p>
              </Link>
            </div>
          </div>
        </div>
      </Page>
    )
  }
}

const mapStateToProps = (state) => {
  return state
}

export default connect(mapStateToProps)(CostAnalysisInvite);



// WEBPACK FOOTER //
// ./src/pages/costAnalysisInvite.js